import React from "react";
import Sections from "./Sections";
import { useTranslation } from "../../i18n/LanguageContext";
const  EditProfileAdmin = ({ isEditMode, handleChange, values, setFieldValue, errors }) => {
   const { t } = useTranslation();
   const fields = [
      {
         sectionName: t("personal-information-title"),
         propertyName: t("name-label"),
         name: "name",
         propertyValue: values?.name,
         isEditMode: isEditMode,
         handleChange: handleChange,
         isRequired: true
      },
      {
         sectionName: "",
         propertyName: t("phone-number"),
         name: "phoneNumber",
         fieldType: "phone",
         propertyValue: values?.phoneNumber,
         isEditMode: isEditMode,
         onSelectChange: (value) => {
            setFieldValue("phoneNumber", value);
         },
         isRequired: true
      }
   ];

   return (
      <>
         {fields?.map((section, index) => (
            <div key={index}>
               <Sections {...section} />
               {errors[section.name] && <div className="text-danger">{errors[section.name]}</div>}
            </div>
         ))}
      </>
   );
};

export default EditProfileAdmin;
